import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_PaneRowAlert from "../templates/K_PaneRowAlert";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PaneRowAlertOptions extends ComponentOptions {
    alertType: "success" | "info" | "warning" | "danger";
    header?: string;
    message?: string;
}

export class PaneRowAlert extends TemplateComponent {

    options: PaneRowAlertOptions;

    constructor(options: PaneRowAlertOptions) {
        super(K_PaneRowAlert, options);
    }

}
